import { combineReducers } from "@reduxjs/toolkit";
import HeaderSlice from "../components/Header/HeaderSlice";
import redirectSlice from "../components/Dashboard/redirectSlice";
import apiSlice from "./AppSlice";

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  HeaderSlice,
  redirectSlice,
});

export default rootReducer;
